var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    { staticClass: "alerts-list-container" },
    _vm._l(_setup.props.alerts, function (alertMessage, index) {
      return _c(
        "div",
        { key: index },
        [
          _c(_setup.AlertsMessagesListItemComponent, {
            attrs: { alert: alertMessage },
          }),
          _c("hr", { staticClass: "divider-line" }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }